import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

type GridLayoutTwoIconProps = IconClientSVGProps & {
  filled?: boolean;
};

export const GridLayoutTwoIcon = forwardRef<
  SVGSVGElement,
  GridLayoutTwoIconProps
>(({ filled, label, ...props }, ref) => {
  return (
    <Icon label={label}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        ref={ref}
        {...props}
      >
        {filled ? (
          <>
            <path d="M8.66667 2H2V18H8.66667V2Z" fill="currentColor" />
            <path d="M11.3333 18H18V2H11.3333V18Z" fill="currentColor" />
            <path d="M8.66667 2H2V18H8.66667V2Z" stroke="currentColor" />
            <path d="M11.3333 18H18V2H11.3333V18Z" stroke="currentColor" />
          </>
        ) : (
          <>
            <path d="M8.66667 2H2V18H8.66667V2Z" stroke="currentColor" />
            <path d="M11.3333 18H18V2H11.3333V18Z" stroke="currentColor" />
          </>
        )}
      </svg>
    </Icon>
  );
});

GridLayoutTwoIcon.displayName = "GridLayoutTwoIcon";
